export default "__VITE_ASSET__DteenWPY__"